<app-stream-overlays [config]="config"></app-stream-overlays>
